module.exports = __webpack_public_path__ + "img/phone.0b9773ef.svg";